import store from "@/store";

const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};
export default [
  {
    meta: {
      title: "EnterRoom"
    },
    path: "/funeral/enterRoom",
    name: "EnterRoom",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/mortuary/EnterRoom.vue")
  },
  {
    meta: {
      title: "Mortuary"
    },
    path: "/funeral/mortuary",
    name: "Mortuary",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/mortuary/Mortuary.vue")
  }
];
